<mdb-tabs (activeTabChange)="onTabChange($event)">
  <!-- TAB CONTENT 1 :  EMPRESA /APP -->
  <mdb-tab>
    <ng-template mdbTabTitle><span><i class="fas fa-industry fa-fw me-2"></i>Empresas / Apps</span></ng-template>
    <div class="d-flex mb-4" style="padding-top: 10px;">
      <mdb-form-control>
        <input mdbInput type="text" class="form-control" id="search-input" (keyup)="search($event)" />
        <label mdbLabel class="form-label" for="search-input">Buscar Empresa</label>
      </mdb-form-control>
      <button title="Crear Compañia" mdbRipple class="btn btn-primary btn-sm ms-3"
        (click)="openModal('add', null, AllApps)">
        <i class="fas fa-industry"> + </i>
      </button>

      <button title="Crear Apps" mdbRipple class="btn btn-primary btn-sm ms-3"
        (click)="openModalApps('add', null, AllCompanies)">
        <i class="fab fa-app-store"> + </i>
      </button>
    </div>
    <hr />
    <div class="datatable table-editor mt-4">
      <table class="table datatable-table" mdbTable mdbTableSort #table="mdbTable" #sort="mdbTableSort"
        [dataSource]="dataSource" [sort]="sort" [pagination]="pagination">
        <thead class="datatable-header">
          <tr>
            <th *ngFor="let header of headers" [mdbTableSortHeader]="header.field" [disableSort]="header.disableSort"
              scope="col">
              <strong>{{ header.label | titlecase }}</strong>
            </th>
          </tr>
        </thead>
        <tbody class="datatable-body" *ngIf="!loading">
          <tr *ngFor="let company of table.data; let index = index" scope="row">
            <td style="min-width: 250px; max-width: 250px">
              <span (mouseenter)="company.showButtons = true" (mouseleave)="company.showButtons = false">
                <span *ngIf="company.ACTIVE === '1'">
                  <i class="fa fa-check text-success"></i>
                </span>
                <span *ngIf="company.ACTIVE !== '1'">
                  <i class="fa fa-circle text-danger"></i>
                </span>
                {{ company.NAME }}
                <button *ngIf="company.showButtons" class="me-2 m-0 p-0 shadow-0 btn btn-lg text-dark edit-button"
                  (click)="openModal('edit', company, AllApps)">
                  <i class="far fa-edit"></i>
                </button>
                <button *ngIf="company.showButtons" class="m-0 p-0 shadow-0 btn btn-lg text-dark delete-button"
                  (click)="onDeleteClick(company)">
                  <span *ngIf="company.ACTIVE === '1'">
                    <i class="fas fa-toggle-on"></i>
                  </span>
                  <span *ngIf="company.ACTIVE !== '1'">
                    <i class="fas fa-toggle-off"></i>
                  </span>
                  <!-- <i class="fas fa-toggle-on"></i> -->
                </button>
              </span>
            </td>
            <td style="min-width: 200px; max-width: 200px">
              <img width="50%" height="50%" [src]="company.LOGO">
            </td>
            <td style="min-width: 250px; max-width: 250px">
              <span *ngFor="let app of company.APPS; let last = last">
                <span (mouseenter)="app.showButtons = true" (mouseleave)="app.showButtons = false">
                  <span *ngIf="app.ACTIVE_APP === '1'">
                    <i class="fa fa-check text-success"></i>
                  </span>
                  <span *ngIf="app.ACTIVE_APP !== '1'">
                    <i class="fa fa-circle text-danger"></i>
                  </span>
                  {{ app.NAME_APP }}
                  <img [src]="app.LOGO_APP ? app.LOGO_APP : '/assets/images/app-logos/Blank_Image.png'" width="24px"
                    height="24px">
                  <button *ngIf="app.showButtons" class="me-2 m-0 p-0 shadow-0 btn btn-lg text-dark edit-button"
                    (click)="openModalApps('edit', app, AllCompanies, table.data)">
                    <i class="far fa-edit"></i>
                  </button>

                  <button *ngIf="app.showButtons" class="m-0 p-0 shadow-0 btn btn-lg text-dark delete-button"
                    (click)="onDeleteClickApps(app,company.ID)">
                    <!-- <i class="fas fa-toggle-on"></i>-->
                    <span *ngIf="app.ACTIVE_APP === '1'">
                      <i class="fas fa-toggle-on"></i>
                    </span>
                    <span *ngIf="app.ACTIVE_APP !== '1'">
                      <i class="fas fa-toggle-off"></i>
                    </span>
                  </button>
                </span><br>
                <!--{{ last ? '' : ', ' }}-->
              </span>
            </td>

          </tr>
        </tbody>
      </table>
      <ng-container *ngIf="loading">
        <div class="datatable-loader bg-light">
          <span class="datatable-loader-inner">
            <span class="datatable-progress bg-primary"></span>
          </span>
        </div>
        <p class="text-center text-muted my-4">Cargando información...</p>
      </ng-container>
      <mdb-table-pagination #pagination rowsPerPageText='Registros por Pagina' ofText='de' [entries]="25"
        [disabled]="loading"></mdb-table-pagination>
    </div>
  </mdb-tab>
  <!-- END TAB CONTENT 1 :  EMPRESA /APP -->

  <!-- TAB CONTENT 2 :  USUARIOS -->
  <mdb-tab>
    <ng-template mdbTabTitle><span><i class="fab fa-app-store fa-fw me-2"></i>Usuarios</span></ng-template>
    <div class="container">
      <div class="row">
        <div class="col">
          <br><br>
          <mdb-form-control>
            <mdb-select [multiple]="false" filter="true" filterPlaceholder="Buscar"
              (valueChange)="onUserSelected($event)">
              <mdb-select-all-option>Seleccionar un usuario</mdb-select-all-option>
              <mdb-option *ngFor="let option of infoUsers" [value]="option.value">{{ option.label }}</mdb-option>
            </mdb-select>
            <label mdbLabel class="form-label">Seleccione un Usuario</label>
          </mdb-form-control>
          <hr>

          <h3>Seleccionar Empresas y Aplicaciones</h3>
          <div style="display: flex; justify-content: flex-end;">
            <button type="button" class="shadow-0 btn btn-md btn-primary" (click)="InsertOrUpdate()"
              [textContent]="'Guardar'"></button>
          </div>
          <form [formGroup]="FormCompanyApps">
            <table class="table">
              <thead>
                <tr>
                  <th>Empresa</th>
                  <th>Aplicaciones</th>
                </tr>
              </thead>
              <tbody>

                <ng-container *ngFor="let company of infoCompaniesApps">
                  <tr>
                    <td>
                      <div class="form-check-inline">
                        <input (change)="onCompanyChange(company.ID, $event.target.checked)" mdbCheckbox
                          class="form-check-input" type="checkbox" [id]="'company-' + company.ID"
                          [formControlName]="'company-' + company.ID" />
                        <div (mouseover)="onCompanyMouseOver(company.ID)" (click)="onCompanyClick(company.ID)">
                          {{ company.NAME }}
                          <span *ngIf="favoriteCompany === company.ID"><i class="fa fa-star"
                              style="font-size:12x;color:black"></i></span> <!-- Star icon for favorite company -->
                        </div>
                      </div>

                    </td>
                    <td>
                      <div *ngFor="let app of company.APPS">
                        <div class="form-check form-switch">
                          <input (change)="onAppChange(app.ID_APP, $event.target.checked)" mdbCheckbox
                            class="form-check-input" type="checkbox" [id]="'app-' + app.ID_APP"
                            [formControlName]="'company-' + company.ID+'app-' + app.ID_APP" />
                          <div (mouseover)="onAppMouseOver(app.ID_APP)" (click)="onAppClick(company.ID,app.ID_APP)">
                            {{ app.NAME_APP }}
                            <span
                              *ngIf="favoriteApp === 'company-'+company.ID+'app-'+app.ID_APP || app.IS_DEFAULT == '1'"><i
                                class="fa fa-star" style="font-size:12px;color:black;"></i></span>
                            <!-- Star icon for favorite app -->
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </form>
        </div>
      </div>
    </div>
  </mdb-tab>
  <!-- END TAB CONTENT 2 :  USUARIOS -->

  <!-- TAB CONTENT 3 :  PERMISOS -->
  <mdb-tab>
    <ng-template mdbTabTitle><span><i class="fas fa-duotone fa-key fa-fw me-2"></i>Permisos</span></ng-template>
    <button title="Clonar perfil" mdbRipple class="btn btn-primary btn-sm ms-3 mb-4 ml-2" style="margin-left: 24px !important"
      (click)="openModalCloneProfile(infoUsers)">
      <i class="fa fa-clone">+</i>
    </button>
    <form [formGroup]="permissionForm" class="mx-4">
      <mdb-form-control>
        <mdb-select formControlName="usersControlName" [multiple]="false" filter="true"
          placeholder='Seleccione un Usuario' filterPlaceholder="Buscar"
          (valueChange)="onUserSelectedTabPermission($event)">
          <mdb-option *ngIf="infoUsers == 0" [value]="0">Seleccione Usuario</mdb-option>
          <mdb-option *ngFor="let option of infoUsers" [value]="option.value">{{
            option.label
            }}</mdb-option>
        </mdb-select>
        <label mdbLabel class="form-label">Seleccione Usuario</label>
      </mdb-form-control>
      <br>
      <mdb-form-control>
        <mdb-select formControlName="companiesControlName" placeholder="Seleccione Empresa"
          [multiple]="false" filter="true"
          (valueChange)="onCompanySelectedTabPermission($event)">
          <mdb-option *ngFor="let option of infoCompanies" [value]="option.value">{{
            option.label
            }}</mdb-option>

        </mdb-select>
        <label mdbLabel class="form-label">Seleccione Empresa</label>
      </mdb-form-control>
      <br>
      <mdb-form-control>
        <mdb-select formControlName="appControlName" placeholder="Seleccione App" [multiple]="false" filter="true"
          (valueChange)="onAppSelectedTabPermission($event)">
          <mdb-option *ngFor="let option of infoApps" [value]="option.value">{{
            option.label
            }}</mdb-option>
        </mdb-select>
        <label mdbLabel class="form-label">Seleccione Aplicación</label>
      </mdb-form-control>
      <br>

      <div class="text-center">
        <button type="button" class="shadow-0 btn btn-md btn-primary" [textContent]="'Guardar Seleccion'"
          (click)="associateMenuToUser()" [disabled]="!permissionForm.valid">
        </button>
      </div>
      <br>
    </form>

    <table *ngIf="(selectedApps.length > 0  || (appsInDataBase > 0 && companiesInDataBase > 0) )"
      class='table table-bordered table-hover mx-4' id='table_1'>
      <tbody>
        <tr>
          <td>MENU</td>
          <td>SUBMENU</td>
          <td>PERMISSION <br>
            <div class="form-check form-switch">
              <input mdbCheckbox (change)="selectAllItems($event)" class="form-check-input" type="checkbox" role="switch" id="selectAllCheckbox"/>
              <label class="form-check-label" for="flexSwitchCheckDefault">Seleccionar Todos</label>
            </div>
          </td>
        </tr>
        <ng-container *ngFor="let item of MenuItems">
          <ng-container *ngIf="item.submenus && item.submenus.length > 0">
            <tr *ngFor="let submenu of item.submenus; let i = index">
              <td *ngIf="i === 0" [attr.rowspan]="item.submenus.length">{{ item.menuName }}</td>
              <td>{{ submenu.submenuName }}</td>
              <td>
                <div class="form-check form-switch">
                <input mdbCheckbox class="form-check-input" type="checkbox"
                    (checkboxChange)="pushOrPopMenuElement($event, submenu.submenuId*1)"
                    id="mdbCheckbox{{submenu.submenuId}}" [checked]="submenu.UserHasMenu == 1 ? true : false" />
                  <label class="form-check-label" for="mdbCheckbox{{submenu.submenuId}}"></label>
                </div>
              </td>
            </tr>
          </ng-container>
          <ng-container *ngIf="!item.submenus || item.submenus.length === 0">
            <tr>
              <td>{{ item.menuName }}</td>
              <td></td>
              <td>
                <div class="form-check form-switch">
                  <!--IDMENU (sin submenu): {{item.menuId}} ( huser_has_menu : {{item.UserHasMenu}})-->
                  <input (checkboxChange)="pushOrPopMenuElement($event, item.menuId*1)" mdbCheckbox
                    class="form-check-input" type="checkbox" id="mdbCheckbox{{item.menuId}}"
                    [checked]="item.UserHasMenu ? true : false" />
                  <label class="form-check-label" for="mdbCheckbox{{item.menuId}}"></label>
                </div>
              </td>
            </tr>
          </ng-container>
        </ng-container>
      </tbody>
    </table>







  </mdb-tab>
  <!--  END CONTENT 3 :  PERMISOS -->

  <!-- TAB CONTENT 4 : MENU -->
  <mdb-tab>
    <ng-template mdbTabTitle><span><i class="fas fa-bars fa-bars fa-fw me-2"></i>Menu</span></ng-template>
    <div class="d-flex mb-4" style="padding-top: 10px;">
      <mdb-form-control>
        <input mdbInput type="text" class="form-control" id="search-input" (keyup)="search($event)" />
        <label mdbLabel class="form-label" for="search-input">Buscar Menu</label>
      </mdb-form-control>
      <button title="Crear Menu" mdbRipple class="btn btn-primary btn-sm ms-3"
        (click)="openModalMenu('add', null, AllCompaniesAndApps, infoMenus, AllChildrenMenus)">
        <i class="fas fa-bars"> + </i>
      </button>
    </div>
    <div class="datatable table-editor mt-4">
      <div class="scrollable-table">
        <table class="table datatable-table table-striped table-bordered table-hover" mdbTable mdbTableSort
          #table="mdbTable" #sort="mdbTableSort" [dataSource]="dataSource" [sort]="sort" [pagination]="pagination">
          <thead class="datatable-header">
            <tr>
              <th *ngFor="let header of headersMenuTable" [mdbTableSortHeader]="header.field"
                [disableSort]="header.disableSort" scope="col"
                [ngStyle]="{'width': header.field === 'NAME' ? '20%' : ''}">
                <strong>{{ header.label | titlecase }}</strong>
              </th>
            </tr>
          </thead>
          <tbody class="datatable-body" *ngIf="!loading">
            <tr *ngFor="let item of infoMenus; let index = index" scope="row">
              <td style="min-width: 250px; max-width: 250px">
                <span (mouseenter)="item.showButtons = true" (mouseleave)="item.showButtons = false">
                  <img width="50%" height="50%" [src]="item.company.LOGO">
                </span>
              </td>
              <td style="min-width: 250px; max-width: 250px">
                <table class="table">
                  <thead>
                    <tr>
                      <th [ngStyle]="{'width': '50%'}"><strong>Aplicación</strong></th>
                      <th [ngStyle]="{'width': '50%'}"><strong>Menu</strong></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let app of item.company.APPS; let last = last">
                      <td (click)="toggleExpanded(app)" (mouseenter)="toggleVisibility(app)"
                        (mouseleave)="toggleVisibility(app)">
                        <div>
                          {{ app.NAME }}
                          <i class="fas fa-eye" *ngIf="app.visibility && !app.expanded"></i>
                          <i class="fas fa-check-circle" *ngIf="app.expanded"></i>
                        </div>
                      </td>
                      <ng-container *ngIf="app.expanded">
                        <tr *ngFor="let menu of app.MENUS">
                          <td>
                            <div (mouseenter)="menu.showButtons = true" (mouseleave)="menu.showButtons = false">
                              <button *ngIf="menu.showButtons"
                                class="me-2 m-0 p-0 shadow-0 btn btn-lg text-dark edit-button"
                                (click)="openModalMenu('edit', menu, AllCompaniesAndApps, infoMenus)">
                                <i class="far fa-edit"></i>
                              </button>
                              {{ menu.NAME }}
                            </div>
                          </td>
                        </tr>
                      </ng-container>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <ng-container *ngIf="loading">
        <div class="datatable-loader bg-light">
          <span class="datatable-loader-inner">
            <span class="datatable-progress bg-primary"></span>
          </span>
        </div>
        <p class="text-center text-muted my-4">Cargando información...</p>
      </ng-container>
      <mdb-table-pagination #pagination rowsPerPageText='Registros por Pagina' ofText='de' [entries]="25"
        [disabled]="loading"></mdb-table-pagination>
    </div>

    <!--END  CONTENT 4 : MENU -->


  </mdb-tab>


</mdb-tabs>
<mdb-loading [show]="loadingFull" [fullscreen]="true">
  <div class="loading-spinner">
    <div class="spinner-border loading-icon" role="status"></div>
    <span class="loading-text">Cargando datos...</span>
  </div>
</mdb-loading>